import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild, input, output } from '@angular/core';

import { CalendarCommonModule, CalendarEvent, CalendarMonthModule, CalendarMonthViewDay } from 'angular-calendar';
import { isSameDay, isSameMonth, isSameYear } from 'date-fns';

import { VisitEvent } from '../../types/visit-event';

@Component({
  selector: 'cam-calendar-by-month',
  imports: [CommonModule, CalendarMonthModule, CalendarCommonModule],
  templateUrl: './calendar-by-month.component.html',
  styleUrls: ['./calendar-by-month.component.scss'],
})
export class ByMonthComponent implements OnInit {
  viewDate = input<Date>(new Date());

  events = input<CalendarEvent<VisitEvent>[]>([]);

  viewDateChanged = output<Date>();

  public selectedDate: Date | null = null;

  @ViewChild('customCellTemplate', { static: true })
  customCellTemplate!: TemplateRef<any>;

  ngOnInit() {
    this.selectedDate = this.viewDate();
  }

  public isCurrentDate(day: { date: Date }): boolean {
    if (!this.selectedDate) {
      return false;
    }
    return (
      isSameDay(day.date, this.selectedDate) &&
      isSameMonth(day.date, this.selectedDate) &&
      isSameYear(day.date, this.selectedDate)
    );
  }

  public daySelected(data: { day: CalendarMonthViewDay }): void {
    this.viewDateChanged.emit(data.day.date);
  }
}
